import styled from 'styled-components';
import { Label } from '@/components/ui/Title';
import Section from '@/components/ui/Section';

export const RelativeSection = styled(Section)`
  position: relative;
`;
export const Wrapper = styled.div`
  width: 100%;
  max-width: 632px;
  margin: 0 auto;
  text-align: center;
`;

export const ShapesWrapper = styled.div`
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: -1;
  width: 1030px;
  height: 640px;
  background: url(/assets/shapes/triage-cta-circle.svg) center center;

  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    background: url(/assets/shapes/triage-cta-circle-tablet.svg) center center;
    width: 772px;
    height: 480px;
  }
  @media (max-width: ${(props) => props.theme.breakpoints.max_sm}px) {
    background: url(/assets/shapes/triage-cta-circle-mobile.svg) center center;
    width: 100%;
    max-width: 515px;
    height: 320px;
  }
`;

export const Subtitle = styled(Label)`
  opacity: unset;
  font-weight: 500;
  padding-bottom: 24px;
`;

export const ButtonWrapper = styled.div`
  display: inline-block;
  a,
  button {
    padding: 15px 32px;
    color: ${(props) => props.theme.colors.grey.dark};
    background-color: transparent;
    border: 1px solid ${(props) => props.theme.colors.grey.dark};
    font-size: 16px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;

    &:hover {
      color: ${(props) => props.theme.colors.white};
      background-color: ${(props) => props.theme.colors.grey.dark};
    }
  }
`;
